import IPostMessage from '../IPostMessage';
import IMonitor, { IConnectedMonitor } from './IMonitor';

/**
 * The `sos.monitors` API groups together methods for providing information about monitors connected to the device.
 *
 * :::note
 * This API is available only on Linux devices.
 * :::
 */
class Monitors implements IMonitor {
	public static MESSAGE_PREFIX: string = 'monitors';

	/** @internal */
	constructor(
		private messagePrefix: string,
		private postMessage: IPostMessage<any>,
	) {}

	/**
	 * The `getList()` method returns a list of monitors currently connected to the device.
	 *
	 * @returns {Promise<IConnectedMonitor[]>} A promise that resolves to an array of connected monitors.
	 * @since 4.0.0
	 */
	public async getList(): Promise<IConnectedMonitor[]> {
		const { monitors } = await this.postMessage({
			type: this.getMessage('get_list'),
		});
		return monitors;
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + Monitors.MESSAGE_PREFIX + '.' + name;
	}
}

export default Monitors;
